import { z } from 'zod';

export const GdprStatus = z.enum(['ACTIVE', 'ARCHIVED']);

export type GdprStatusT = z.infer<typeof GdprStatus>;
